<soft-page>
  @if (loading$ | async) {
    @for (_ of [1, 2, 3, 4]; track $index) {
      <div class="soft-card rounded-m flex flex-row flex-nowrap center-v overflow-hidden relative mb-3">
        <div class="absolute top-0 bottom-0 left-0 w-1.5 rounded-l-m bg-primary"></div>
        <div class="flex flex-row justify-between flex-nowrap center-v flex-1 p-2">
          <div class="flex flex-col justify-center flex-nowrap flex-1 mr-1">
            <div class="mt-1 mb-1">
              <soft-loading-skeleton style="width: 60%; height: 1.1rem" />
            </div>
            <div class="mb-1">
              <soft-loading-skeleton style="width: 80%; height: 0.875rem" />
            </div>
            <div class="flex flex-row items-center justify-between flex-nowrap w-full mt-1 mb-1">
              <soft-loading-skeleton style="width: 8rem; height: 0.875rem" />
              <soft-loading-skeleton style="width: 5rem; height: 0.875rem" />
            </div>
          </div>
          <i class="fa-regular fa-chevron-right text-sm color-lighter ml-2"></i>
        </div>
      </div>
    }
  } @else {
    @if (auftraege$ | async; as auftraege) {
      @if (auftraege.length === 0) {
        <div class="flex flex-col items-center justify-center text-center py-16 px-6 text-light">
          <i class="fa-regular fa-face-frown-open text-6xl mb-4 opacity-60"></i>
          <p class="text-base">{{ '#TRANSPORT.LIST.NO_DATA' | translate }}</p>
        </div>
      } @else {
        @for (auftrag of auftraege$ | async; track auftrag; let i = $index) {
          <div class="flex flex-col flex-nowrap pb-3">
            <soft-tp-card [auftrag]="auftrag" />
          </div>
        }
        <div class="flex flex-row justify-center mt-2 pb-5 pt-2 pr-2 pl-2 mb-3">
          <span class="text-sm color-light">
            {{ '#TRANSPORT.LIST.END_INFO' | translate }}
          </span>
        </div>
      }
    }
  }
</soft-page>
